<!--
 * @Description: 水表复接申请
--> 
<template>
  <div class="meter-transfer-form">
    <van-nav-bar
      left-text="返回"
      :title="$route.meta.title"
      @click-left="$comm.onClickLeft"
      left-arrow
      fixed
      >
      <template #left>
        <span class="iconfont iconshang comm-rotate-270"></span>
        <span class="comm-return">返回</span>
      </template>
    </van-nav-bar>
    <div class="comm-topbar-height" v-show="$comm.titleShow()"></div>
    <van-form @submit="onSubmit">
      <div class="comm-form-group">原用户信息</div>
      <van-field
        readonly
        required
        clickable
        :value="form.userno"
        label="用户号"
        placeholder="请选择用户号"
        :rules="[{ required: true, message: '点击选择用户号' }]"
      >
        <template v-if="!$route.query.readonly" #button>
          <van-button class="comm-small-btn" native-type="button" @click="choiceClick()">选择</van-button>
        </template>
      </van-field>
      <van-field
        required
        readonly
        v-model="form.uname"
        label="用户名称"
        placeholder="系统获取"
        @change="nameChange()"
        :rules="[{ required: true, message: '请输入用户名称' }]"
        >
        <template #input>
          <span style="color:#969799;">{{form.uname|capitalize}}</span>
        </template>
      </van-field>
      <van-field
        required
        readonly
        v-model="form.addr"
        label="用户地址"
        placeholder="系统获取"
        :rules="[{ required: true, message: '请输入用户地址' }]"
      />
      <van-field
        required
        readonly
        v-model="form.fixaddr"
        label="装表地址"
        placeholder="系统获取"
        :rules="[{ required: true, message: '请输入装表地址' }]"
      />
      <van-field
        required
        readonly
        clickable
        name="datetimePicker"
        v-model="form.appointment"
        label="预约日期"
        placeholder="点击选择预约日期"
        @click="showPicker = true"
        :rules="[{ required: true, message: '请选择预约日期' }]"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-datetime-picker
          type="date"
          title="选择年月日"
          :min-date="$currentDate"
          :max-date="$maxDate"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>
      <van-field
        required
        v-model="form.idenno"
        label="户主身份证号"
        placeholder="户主身份证号"
        :rules="[{ pattern: $patternId, message: '请输入正确格式' }]"
      />
      <!-- :rules="[{ pattern: $pattern, message: '请输入正确格式' }]" -->
      <van-field
        required
        v-model="form.mobile"
        label="户主手机号"
        placeholder="系统获取"
        :rules="[{ pattern: $pattern, message: '请输入正确格式' }]"
        readonly
        >
        <template #input>
          <span style="color:#969799;">{{form.mobile|capitalize}}</span>
        </template>
      </van-field>
      <van-field
        required
        :rules="[{ required: true, message: '请输入联系人' }]"
        v-model="form.operator"
        name="联系人"
        label="联系人"
        @change="nameChange()"
        placeholder="联系人"
      />
      <!-- :rules="[{ validator: $comm.validator, message: '请输入正确格式' }]" -->
      <van-field
        required
        v-model="form.opmobile"
        name="validator"
        label="联系人手机"
        placeholder="联系人手机"
        :rules="[{ pattern: $pattern, message: '请输入正确格式' }]"
      />
      <van-field
        v-model="form.opidenno"
        label="联系人身份证"
        placeholder="联系人身份证"
        :rules="[{ validator: $comm.validatorId, message: '请输入正确格式' }]"
      />
      <van-field
        v-model="form.remark"
        rows="2"
        autosize
        label="备注"
        type="textarea"
        maxlength="500"
        placeholder="请输入留言"
        show-word-limit
      />
      <div class="comm-form-group">证件资料上传</div>
      <van-field
        :required="!isNameSame"
        name="uploaderMst"
        label="户主身份证"
        :rules="[{ 
          required: !isNameSame, 
          message: $idcardmsg
        }]"
        >
        <template #input>
          <van-uploader
            :deletable="!$route.query.readonly"
            :show-upload="!$route.query.readonly"
            multiple
            v-model="uploaderMst"
            :after-read="afterReadMaster"
            @delete="onDeleteMaster"
            />
        </template>
      </van-field>
      <van-field
        required
        name="uploaderHs"
        label="房屋产权证"
        :rules="[{ required: true, message: '请上传房屋产权证' }]"
      >
        <template #input>
          <van-uploader
            :deletable="!$route.query.readonly"
            :show-upload="!$route.query.readonly"
            multiple
            v-model="uploaderHs"
            :after-read="afterReadHourse"
            @delete="onDeleteHourse"
            />
        </template>
      </van-field>
      <van-field name="uploaderOpt" label="联系人身份证">
        <template #input>
          <van-uploader
            :deletable="!$route.query.readonly"
            :show-upload="!$route.query.readonly"
            multiple
            v-model="uploaderOpt"
            :after-read="afterReadOpt"
            @delete="onDeleteOpt"
            />
        </template>
      </van-field>
      <van-field
        v-if="!$route.query.readonly"
        required
        v-model="form.smscode"
        label="验证码"
        placeholder="请输入验证码"
        :rules="[{ required: true, message: '请输入验证码' }]"
      >
        <template #button>
          <sms-btn :phone="form.opmobile"></sms-btn>
        </template>
      </van-field>
      <div v-if="!$route.query.readonly" style="margin:17px 16px;margin-bottom:36.5px;">
        <van-button
          type="info"
          color="#1677FF"
          size="large"
          style="height:44px;"
          native-type="submit"
          >
          确认提交
        </van-button>
      </div>
    </van-form>
    <van-popup
      v-model="popShow"
      class="form-pop"
      >
      <user-select-pop :userList="userList" @onSelectClick="onSelectClick"></user-select-pop>
    </van-popup>
  </div>
</template>

<script>
import smsBtn from '@/components/smsBtn.vue'
import UserSelectPop from '@/components/UserSelectPop.vue'
export default {
  name: 'ReconnectForm',
  components: {
    smsBtn,
    UserSelectPop
  },
  filters: {
    capitalize: function (value) {
      if (!value) return '系统获取'
      value = value.toString()
      let result = ''
      if(value.length>3){
        result = value.substring(0,3)+"****"+value.substring(value.length-4)
      }else{
        result = "*"+value.substring(1,value.length)
      }
      return result
    }
  },
  data() {
    let cuser_info = null
    if(localStorage.getItem('cuser_info')){
      cuser_info = JSON.parse(localStorage.getItem('cuser_info'))
    }
    return {
      popShow: false,
      // masterUrls: [{ url: 'https://img.yzcdn.cn/vant/leaf.jpg' }],
      uploaderMst: [], // vant自带缩略图站位
      uploaderHs: [],
      uploaderOpt: [],
      masterUrls: [],
      hourseUrls: [],
      optUrls: [],
      message: '',
      radio: '1',
      form: {
        userno: '', // 用户编号
        addr: '', // 用户地址
        fixaddr: '', // 装表地址
        uname: '',
        idenno: '',
        mobile: '',
        smscode: '',
        operator: cuser_info?cuser_info.uname:'',
        opmobile: cuser_info?cuser_info.mobile:'',
        opidenno: '',
        appointment: '',
        remark: '',
        attach: []
      },
      value: '',
      showPicker: false,
      isNameSame: false,
      userList: JSON.parse(localStorage.getItem('userList'))
    }
  },
  mounted() {
    if(this.$route.query.busscode&&this.$route.query.bussno){
      this.$comm.getBussInfo(this.$route.query.busscode, this.$route.query.bussno).then(res => {
        this.form = res
        let result = this.$comm.analysisAttach(res)
        this.uploaderMst = result.uploaderMst
        this.uploaderHs = result.uploaderHs
        this.uploaderOpt = result.uploaderOpt
        this.masterUrls = result.masterUrls
        this.hourseUrls = result.hourseUrls
        this.optUrls = result.optUrls
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'BusinessProgress') {
      to.meta.isUseCache = true
    }
    next()
  },
  methods: {
    nameChange(){
      if(this.form.uname===this.form.operator){
        this.isNameSame = true
      }else{
        this.isNameSame = false
      }
    },
    onConfirm(time) {
      // eslint-disable-next-line no-undef
      this.form.appointment = moment(time).format("YYYY-MM-DD");
      this.showPicker = false;
    },
    afterReadMaster (file) {
      this.$loading('上传中...')
      this.$http.post(this.$api.fileUpload, {
        fileext: this.$comm.extname(file.file.name),
        base64: file.content
      }).then(res => {
        this.$clear()
        if (res.code === '000') {
          this.masterUrls.push(res.data)
        } else {
          this.$toast('上传失败')
        }
      })
    },
    afterReadHourse (file) {
      this.$loading('上传中...')
      this.$http.post(this.$api.fileUpload, {
        fileext: this.$comm.extname(file.file.name),
        base64: file.content
      }).then(res => {
        this.$clear()
        if (res.code === '000') {
          this.hourseUrls.push(res.data)
        } else {
          this.$toast('上传失败')
        }
      })
    },
    afterReadOpt (file) {
      this.$loading('上传中...')
      this.$http.post(this.$api.fileUpload, {
        fileext: this.$comm.extname(file.file.name),
        base64: file.content
      }).then(res => {
        this.$clear()
        if (res.code === '000') {
          this.optUrls.push(res.data)
        } else {
          this.$toast('上传失败')
        }
      })
    },
    onDeleteMaster (file, detail) {
      this.masterUrls.splice(detail.index, 1)
    },
    onDeleteHourse (file, detail) {
      this.hourseUrls.splice(detail.index, 1)
    },
    onDeleteOpt (file, detail) {
      this.optUrls.splice(detail.index, 1)
    },
    onSelectClick (user) {
      this.popShow = false
      this.form.userno = user.userno
      // this.form.uname = user.uname
      this.form.addr = user.addr
      this.form.fixaddr = user.fixaddr
      this.$comm.getUserInfo(this.form.userno).then(res=>{
        this.form.uname = res.yhmc
        this.form.mobile = res.yddh
      })
    },
    choiceClick () {
      this.popShow = true
    },
    onSubmit() {
      this.form.attach = this.$comm.getAttach(this.masterUrls, this.hourseUrls, this.optUrls, [])
      this.$http.post(this.$api.personReconnect, this.form).then(res => {
        if (res.code==='000') {
          this.$router.push({
            path: '/business/success',
            query: {
              title: this.$route.meta.title,
              from: '业务办理'
            }
          })
        } else {
          this.$toast(res.msg)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.meter-transfer-form{
  /deep/.van-radio-group.van-radio-group--horizontal{
    font-size:12px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(33,33,33,1);
    .van-radio--horizontal{
      margin-right: 0;
      margin-left: 4px;
      .van-radio__label{
        margin-left: 2px;
      }
    }
  }
  .form-pop{
    width:85%;
    height:60%;
    border-radius:4px;
    font-size:12px;
    .user-list{
      background:rgba(255,255,255,1);
      padding: 21px 16px;
    }
  }
}
</style>